import { render, staticRenderFns } from "./CustomerTable.vue?vue&type=template&id=6a724dc7&"
import script from "./CustomerTable.vue?vue&type=script&lang=js&"
export * from "./CustomerTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports